import React from "react";
import styles from '../TemplatesPreview.module.scss';

const ElementAddress = ({ value }) => {
  const handleClick = () => {
    const encodedAddress = encodeURIComponent(value);
    const mapsUrl = `https://yandex.ru/maps/?text=${encodedAddress}`;
    window.open(mapsUrl, "_blank");
  };
  
  return (
    <div style={{display: 'flex'}}>
      <div className={styles.groupName}>Адрес:&nbsp;</div>
      <div className={styles.groupCOnteiner}>
        <a onClick={handleClick} target="_blank" rel="noopener noreferrer" className={styles.groupValue}>{value}</a>
      </div>
    </div>
  )
}

export default ElementAddress;